import React from "react";
import {Button as RAButton} from "react-admin";

import {Tooltip} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import {translateWrapper} from "../translateWrapper";
import {DEFAULT_CLASSNAME} from "../../config/const";

interface ImportButtonProps {
    variant: "text" | "outlined" | "contained";
    label: string;
    clickImportButton: () => any;
    onFileAdded: (e: React.ChangeEvent<HTMLInputElement>) => any;
    onRef: (el: HTMLInputElement) => any;
    className?: string;
}

export function ImportButton(props: ImportButtonProps) {
    const {variant, label, clickImportButton, onFileAdded, onRef} = props;
    const translate = translateWrapper();
    return (
        <Tooltip title={translate("csv.buttonMain.tooltip")}>
            <div>
                <RAButton
                    color="primary"
                    component="span"
                    variant={variant}
                    label={label}
                    onClick={clickImportButton}
                    className={
                        props.className && !props.className.includes(DEFAULT_CLASSNAME.import_button)
                            ? props.className
                            : ''
                    }
                    style={
                        props.className && !props.className.includes(DEFAULT_CLASSNAME.import_button)
                            ? {whiteSpace: "nowrap"}
                            : {}
                    }
                >
                    <GetAppIcon style={{transform: "rotate(180deg)", fontSize: "20"}}/>
                </RAButton>
                <input
                    ref={onRef}
                    type="file"
                    style={{display: "none"}}
                    onChange={onFileAdded}
                    accept=".csv,.tsv"
                />
            </div>
        </Tooltip>
    );
}
